import { StatusTypes } from '@chegg/commerce-utils';

/**
 * transform the response data to something consumable by the Message component
 * @param response
 */
export var transformMopResponseData = function transformMopResponseData(response) {
  var _ref = response.data,
    mop = _ref.mopV2,
    errors2 = _ref.errors2;
  if (mop) {
    return {
      message: {
        text: 'Card successfully added.',
        type: StatusTypes.SUCCESS
      },
      rawData: response.data
    };
  } else if (errors2) {
    return {
      message: {
        text: errors2[0].message,
        type: StatusTypes.ERROR
      },
      rawData: response.data
    };
  } else {
    return;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/helpers/transformMopResponseData.js
// module id = 1481
// module chunks = 11